import React, { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';

import NormalButton from '@/components/button/normal';
import OversizeC2AButton from '@/components/button/oversize-c2a';
import useModal from '@/components/modal/use-modal';
import getThemedButtonProps from '@/lib/get-themed-button-props';
import { getQueryParamValue, isBrowser } from '@/lib/utils';
import { selectGlobalPageTheme } from '@/store/slices/global';
import {
  LotteryFormButton as LotteryFormButtonType,
  LotteryState,
} from '@/types/views/generic';

import LotteryForm from '../form';

const FORM_ID_QUERY_PARAM_KEY = 'openFormPotId';

type LotteryFormButtonProps = Omit<LotteryFormButtonType, 'componentType'> & {
  isOversize?: boolean;
};

const LotteryFormButton: FC<LotteryFormButtonProps> = ({
  ctaText,
  lotteryTitle,
  lotteryPot,
  isOversize = false,
  initialLotteryState = LotteryState.Form,
}) => {
  const { isModalOpen, toggleModal, setIsModalOpen } = useModal();

  const onCloseModal = () => setIsModalOpen(false);

  useEffect(() => {
    const potIdFromQueryUrl = getQueryParamValue(FORM_ID_QUERY_PARAM_KEY);

    if (Number(potIdFromQueryUrl) === lotteryPot.potId) {
      toggleModal();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const pageTheme = useSelector(selectGlobalPageTheme);
  const buttonProps = getThemedButtonProps(pageTheme);

  return (
    <div>
      {isOversize ? (
        <div onClick={toggleModal}>
          <OversizeC2AButton text={ctaText} />
        </div>
      ) : (
        <NormalButton {...buttonProps} text={ctaText} onClick={toggleModal} />
      )}

      {isModalOpen && isBrowser() && (
        <LotteryForm
          lotteryTitle={lotteryTitle}
          lotteryPot={lotteryPot}
          initialLotteryState={initialLotteryState}
          onClose={onCloseModal}
        />
      )}
    </div>
  );
};

export default LotteryFormButton;
